import React, { useState, useEffect, useRef } from "react"

import ClickAwayListener from "@material-ui/core/ClickAwayListener"
import Popper from "@material-ui/core/Popper"
import IconButton from "@material-ui/core/IconButton"
import { QuestionIcon, CloseIcon } from "./Icons"
import { type ICard } from "./helper"

import * as styles from "./gridWithTooltip.module.scss"
import { DLClickEventExtended } from "../../helpers/WatcherDL/DLEvents"
import getTextFromNode from "../../helpers/getTextFromNode"

const Card = ({ title, id, Image, alt, tooltipText }: ICard) => {
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null)
  const buttonRef = useRef<HTMLButtonElement>(null)
  const open = Boolean(anchorEl)

  useEffect(() => {
    const handleScroll = () => {
      if (open) {
        setAnchorEl(null)
      }
    }

    if (open) {
      window.addEventListener("scroll", handleScroll, true)
    }

    return () => {
      window.removeEventListener("scroll", handleScroll, true)
    }
  }, [open])

  return (
    <div key={id} className={`${styles.card} ${styles[`card${id}`]}`}>
      <Image alt={alt} className={styles.img} />
      <div className={styles.title}>
        {title}
        {tooltipText && (
          <>
            <IconButton
              classes={{ root: styles.iconQuestion }}
              ref={buttonRef}
              onClick={(e) => {
                e.stopPropagation()
                setAnchorEl(anchorEl ? null : e.currentTarget)

                if (!anchorEl) {
                  DLClickEventExtended({
                    name: "Tooltip",
                    eventCategory: "click_tooltip",
                    eventAction: getTextFromNode(title).slice(0, 30),
                    placement: "benefits",
                  })
                }
              }}
            >
              <QuestionIcon />
            </IconButton>

            <Popper open={open} anchorEl={anchorEl} placement="bottom">
              <ClickAwayListener
                onClickAway={(event) => {
                  if (!(buttonRef.current && buttonRef.current.contains(event.target as Node))) {
                    setAnchorEl(null)
                  }
                }}
              >
                <div className={styles.tooltipContent}>
                  <div className={styles.tooltipText}>{tooltipText}</div>

                  <IconButton
                    classes={{ root: styles.iconClose }}
                    onClick={() => setAnchorEl(null)}
                  >
                    <CloseIcon />
                  </IconButton>
                </div>
              </ClickAwayListener>
            </Popper>
          </>
        )}
      </div>
    </div>
  )
}

export default Card
